import { create, show, useModal } from "@ebay/nice-modal-react";

import DeleteConfirmationModal from "ds/components/DeleteConfirmationModal";

type AssistantPanelChatDeleteConfirmationModalProps = {
  name: string;
  onConfirm: () => void;
};

const AssistantPanelChatDeleteConfirmationModal = create(
  function AssistantPanelChatDeleteConfirmationModal({
    name,
    onConfirm,
  }: AssistantPanelChatDeleteConfirmationModalProps) {
    const modal = useModal();

    const handleOnConfirm = () => {
      onConfirm();
      modal.hide();
    };

    return <DeleteConfirmationModal title="Delete chat?" name={name} onConfirm={handleOnConfirm} />;
  }
);

export const showAssistantPanelChatDeleteConfirmationModal = (
  props: AssistantPanelChatDeleteConfirmationModalProps
) => show(AssistantPanelChatDeleteConfirmationModal, props);
